import matchingFormStandard from './matchingformstandard';
import matchingFormTraditions from "./matchingformtraditions";

export default {
    "matchingFormStandard": matchingFormStandard,
    "matchingFormTraditions": matchingFormTraditions
};